module.exports = __webpack_public_path__ + "img/029.004b512a.png";